import { DatePipe, registerLocaleData } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import localeEsAr from '@angular/common/locales/es-AR';

//*MODULOS
import { SeguridadModule } from './shared-module/seguridad/seguridad.module';
import { AuthGuard } from './shared-module/seguridad/services/auth.guard';
import { AuthService } from './shared-module/seguridad/services/auth.service';
import { SharedModule } from './shared/shared.module';

//* MODULOS EN CONSTRUCCIONES
import { SustentosModule } from './aplicaciones-modulos/sustentos/sustentos.module';
import { FinanzasModule } from './aplicaciones-modulos/financiero/finanzas.module';
import { DistribuidorModule } from './aplicaciones-modulos/distribuidores/distribuidor.module';
import { vmiModule } from './aplicaciones-modulos/vmi/vmi.module';
import { IndicadoresVivosModule } from './aplicaciones-modulos/indicadores-vivos/indicadores-vivos.module';
import { ComedorModule } from './aplicaciones-modulos/comedor/comedor.module';
import { ApprovalDashboardModule } from './aplicaciones-modulos/approval-dashboard/approval-dashboard.module';

//*LIBRERIAS
import { AgGridModule } from 'ag-grid-angular';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ChartModule, HIGHCHARTS_MODULES } from 'angular-highcharts'
import * as HighchartsMore from 'highcharts/highcharts-more.src'
import * as HighchartsSolidGauge from 'highcharts/modules/solid-gauge'

//*COMPONENTES
import { HomeComponent } from './views/home/home.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LfsaBotonEditarGridComponent } from './shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { AdminSeguridadModule } from './shared-module/admin-seguridad/admin-seguridad.module';
import { TooltipModule } from 'ng2-tooltip-directive';
import { HorasExtrasModule } from "./aplicaciones-modulos/horas-extras/horas-extras.module";
import { AuthInterceptorService } from './shared/utils/auth-interceptor-service';
import { RPlusModule } from './aplicaciones-modulos/rplus/rplus.module';
import { PromocionesModule } from './aplicaciones-modulos/promociones/promociones.module';
import { TemplateCellRenderer } from './aplicaciones-modulos/portal-compras/views/administrador/frm-solped-rplus/template-cell-renderer.component';
import { ToastrModule } from 'ngx-toastr';
import { InterceptorsModule } from './aplicaciones-modulos/portfolio/interceptors/interceptors.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DateTimePipe } from './shared-module/pipes/date-time.pipe';
import { BalanzaModule } from './aplicaciones-modulos/balanza/balanza.module';
import {AutoconsumoModule} from "./aplicaciones-modulos/autoconsumo/autoconsumo.module";
import { ComisionesModule } from './aplicaciones-modulos/comisiones/comisiones.module';
import { IoIndustiasModule } from './aplicaciones-modulos/io-industrias/io-industrias.module';
import { EmpTercerosModule } from './aplicaciones-modulos/emp-terceros/emp-terceros.module';
import { SypralModule } from './aplicaciones-modulos/spyral/spyral.module';
import { EssencialModule } from './aplicaciones-modulos/sd-essential/essencial.module';
import { LogisticaModule } from './aplicaciones-modulos/logistica/logistica.module';
import { SeguridadDAModule } from './aplicaciones-modulos/seguridadDA/seguridadDA.module';
import { PlmModule } from './aplicaciones-modulos/plm-calidad/plm.module';




registerLocaleData(localeEsAr, 'es-Ar');
@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    TemplateCellRenderer,
    DateTimePipe,
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    //*MODULOS EN ETAPA DE CONSTRUCCION
    vmiModule,
    // TvcModule,
    SustentosModule,
    FinanzasModule,
    // AdaptiveModule,
    // PdvInvolvesModule,
    DistribuidorModule,
    // EppModule,
    // UniformeModule,
    LogisticaModule,
    //*FIN
    //*MODULOS EN PRODUCTIVO
    HorasExtrasModule,
    AutoconsumoModule,
    RPlusModule,
    PromocionesModule,
    BalanzaModule,
    ComisionesModule,
    IndicadoresVivosModule,
    IoIndustiasModule,
    ComedorModule,
    EmpTercerosModule,
    SypralModule,
    EssencialModule,
    ApprovalDashboardModule,
    SeguridadDAModule,
    PlmModule,
    //*FIN
    AgGridModule.withComponents([LfsaBotonEditarGridComponent]),
    ChartModule,
    HttpClientModule,
    SharedModule,
    SeguridadModule,
    AdminSeguridadModule,
    AppRoutingModule,
    NgMultiSelectDropDownModule.forRoot(),
    TooltipModule,
    BrowserModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(), // ToastrModule added
    InterceptorsModule // Interceptors Module added
  ],
  providers: [
    AuthService,
    AuthGuard,
    DatePipe,
    {
      provide: LOCALE_ID,
      useValue: 'es-Ar'
    },
    {
      provide: HIGHCHARTS_MODULES,
      useFactory: () => [HighchartsMore, HighchartsSolidGauge]
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true
    }
  ],
  entryComponents: [TemplateCellRenderer],
  bootstrap: [AppComponent]
})
export class AppModule { }
